import { vsName as componentName } from "./component";
import {
  MachineDetailTabsProvider,
  vsProviderName as machineDetailTabsProviderName,
} from "../../../../../shared/components/views/machines/detail/tabs";
import { MachineGateway } from "../../../../models/machine";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../../records/server/serverUtility";

export function machineDetailPartsComponentConfig(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider.addElement({
    displayName: "Parts",
    id: "parts",
    uiSrefFragment: "parts",
    requiredPermission: "partView",
    stateDefinition: {
      url: "/parts",
      component: componentName,
      resolve: {
        machine: ["machine", (machine: MachineGateway) => machine],
        machineParts: [
          "machine",
          serverUtilityName,
          (machine: MachineGateway, serverUtility: ServerUtility) => {
            const machineId = machine.Id;
            return serverUtility.sendApiRequest({
              method: "GET",
              url: `/api/machines/${machineId}/parts`,
            });
          },
        ],
      },
    },
  });
}
machineDetailPartsComponentConfig.$inject = [machineDetailTabsProviderName];
